import React, { useEffect, useState, useContext } from 'react'
import { getAge, humanReadableTimePassed } from '../../../Helper/helpers'
import styles from './CAEJWMEachProfile.module.css'
import { useParams } from 'react-router'
import { IoMdCall, IoIosWarning } from "react-icons/io";
import { CgSpinner } from "react-icons/cg";
import { MdOutlineFileDownloadDone } from "react-icons/md";
import AuthContext from '../../../store/auth-context'
import { BASE_URL_API } from '../../../References/urls'

const CAEJWMEachProfile = (props) => {
    const { item, activeProfile, activeProfileToggler } = props
    const [addingStatus, setAddingStatus] = useState('untouched') // success, error, loading, untouched
    const authCtx = useContext(AuthContext)


    const { jobIdentifier } = useParams()
    const addToCallStack = async () => {
        setAddingStatus('loading')
        console.log(jobIdentifier, item, authCtx)
        // setAddingStatus('success')
        const response = await fetch(BASE_URL_API + "/addToCallStack",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    fullName : item?.stylist_name, 
                    stylistIdentifier: item?.stylist_id,
                    jobIdentifier: jobIdentifier,
                    phoneNumber : item?.contact_number,
                    executiveIdentifier: authCtx.userIdentifier
                })
            });

        if (!response.ok) {
            setAddingStatus('error')
            console.log("Something went wrong : Server Error");
        } else {
            const responseData = await response.json();
            if (responseData.status === "success") {
                setAddingStatus('success')
            } else {
                if (responseData.message === "token Expired, please login again!") {
                    authCtx.logout()
                } else {
                    setAddingStatus('error')
                }
            }
            console.log(responseData)
        }
    }

    return (
        <div className={styles.eachProfileWrapper} onClick={() => activeProfileToggler(item)}>
            <div>
                <span className={styles.stylist_name}>{item?.stylist_name}, </span>
                <span className={styles.stylist_gender}>{item?.stylist_gender}, {item?.maritalStatus}, {getAge(item?.stylist_birthdate)} years old</span>
            </div>
            <div className={styles.registeredTxt}>
                Registered {humanReadableTimePassed(item?.registred_on)} on stylelink!
            </div>
            <div>
                <div className={styles.contact_number}

                >
                    {item?.contact_number}
                </div>
            </div>
            <div>
                {item?.currentLocation}
            </div>
            <div className={styles.domainWrapper}>
                <div className={styles.eachDomain}>
                    {item?.primaryWorkDomain}
                </div>
                {item?.secondaryWorkDomain &&
                    <div className={styles.eachDomain}>
                        {item?.secondaryWorkDomain}
                    </div>
                }
                {item?.tertiaryWorkDomain &&
                    <div className={styles.eachDomain}>
                        {item?.tertiaryWorkDomain}
                    </div>
                }
            </div>
            <div className={styles.salaryAndDistanceWrapper}>
                <div>
                    <div>
                        {parseFloat(item?.distance).toFixed(2)} kms
                    </div>
                    <div>
                        ₹{item?.minimumSalaryExpectation}
                    </div>
                </div>
                {addingStatus === 'untouched' &&
                    <div onClick={() => addToCallStack(item)}>
                        <IoMdCall size={20} color={"#000"} />
                    </div>
                }
                {addingStatus === 'loading' &&
                    <div onClick={() => addToCallStack(item)}>
                        <CgSpinner className={styles.spinner} size={20} color={"#000"} />
                    </div>
                }
                {addingStatus === 'success' &&
                    <div onClick={() => addToCallStack(item)}>
                        <MdOutlineFileDownloadDone size={20} color={"green"} />
                    </div>
                }
                {addingStatus === 'error' &&
                    <div onClick={() => addToCallStack(item)}>
                        <IoIosWarning className={styles.error} size={20} color={"red"} />
                    </div>
                }

            </div>
        </div>
    )
}

export default CAEJWMEachProfile